import { render, staticRenderFns } from "./AstralCard.vue?vue&type=template&id=37b4003b&scoped=true&"
import script from "./AstralCard.vue?vue&type=script&lang=js&"
export * from "./AstralCard.vue?vue&type=script&lang=js&"
import style0 from "./AstralCard.vue?vue&type=style&index=0&id=37b4003b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4003b",
  null
  
)

export default component.exports